import { Box } from '@ethings/ui-toolkit';
import { styled } from '@mui/material';
import { sideMenuTransitionStyles } from './side-menu.utils';

export const SideMenuBox: typeof Box = styled(Box)(({ theme }) => ({
  borderRadius: `${typeof theme.shape.borderRadius === 'string' ? theme.shape.borderRadius : `${theme.shape.borderRadius}px`}`,
  backgroundColor: theme.sidebar.secondaryBackground,
  ...sideMenuTransitionStyles,
}));
